module.exports = __webpack_public_path__ + "static/img/materialsInfo15.ba8d6a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo15.png
// module id = KHuT
// module chunks = 2